import React, { useState, useEffect } from 'react';
import Nav from './Nav';
import Main from './Main';
import Blogs from './Blogs';
import { useDispatch } from 'react-redux';
import { loginActions } from '../store/loginSlice';
import { articleActions } from '../store/articleSlice';
import { ToastContainer } from 'react-toastify';
import Loader from './Loader';
import MobileNav from './MobileNav';
import classes from './Home.module.css';
import { Helmet } from 'react-helmet';

import { auth, messaging } from '../config/firebase';
import { getToken} from 'firebase/messaging';

const Home = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  // async function requestPermission() {
  //   const permission = await Notification.requestPermission();

  //   if(permission === 'granted'){
  //     // generate token
  //     const token = await getToken(messaging, {vapidKey: 'BCnZ1sCCtmF33wGLRYe6UiB_dMzq5sTn5Pket21SNNmxtBdqhsJdcGbdXm5llY55Q8JsDg2D-D2_QnTLuLQnv6U'});
  //     console.log("token",token);
  //   }
  //   else if(permission === 'denied'){
  //     alert('you denied for the notification');
  //   }
  // }

  // useEffect(()=>{
  //   requestPermission();
  // },[]);

  useEffect(() => {
    setLoading(true);

    auth.onAuthStateChanged((user) => {
      if (user) {
        dispatch(loginActions.login());
      }
    });

    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch('https://codinguniverse-20c51-default-rtdb.firebaseio.com/article.json');
      const data = await response.json();
      dispatch(articleActions.replace(data.items));
    }
    fetchData();
  }, [dispatch]);

  return (
    <div className={classes.home}>

      <Helmet>
        <title>Coding Universe</title>
        <meta property="og:description" content="Explore, Learn, and Empower Your Coding Journey" />
        <meta property="og:image" content="https://cdn-icons-png.flaticon.com/128/876/876019.png" />
        <meta property="og:url" content="https://codinguniverse.netlify.app/" />
        <meta property="og:type" content="website" />
      </Helmet>

      {loading && <Loader></Loader>}
      <Nav></Nav>
      <MobileNav></MobileNav>
      <Main></Main>
      <Blogs></Blogs>
      <ToastContainer></ToastContainer>
    
    </div>
  )
}
export default Home;